import $ from "jquery"
import "slick-carousel"

const crebosCulture = () => {
  const init = () => {
    slick()
  }

  const slick = () => {
    const el = {
      slider: ".js-CrebosCulture__Slider",
      navs: ".js-CrebosCulture__Navigation",
      gallery: ".js-CrebosCulture__Gallery",
    }

    if ($(el.slider || el.navs || el.gallery).length === 0) return

    $(el.slider).slick({
      dots: false,
      arrows: false,
      infinite: false,
      speed: 1000,
      slidesToShow: 1,
      slidesToScroll: 1,
      asNavFor: el.navs,
      swipe: false,
      touchMove: false,
      autoplay: true,
      adaptiveHeight: true,
      onAfterChange: function (slickSlider, i) {
        //remove all active class
        $(el.navs).removeClass("slick-active")
        //set active class for current slide
        $(el.navs).eq(i).addClass("slick-active")
      },
      responsive: [
        {
          breakpoint: 575.98,
          settings: {
            adaptiveHeight: true,
          },
        },
      ],
    })

    $(el.navs).slick({
      vertical: true,
      verticalSwiping: true,
      slidesToShow: 6,
      slidesToScroll: 1,
      infinite: false,
      speed: 1000,
      arrows: false,
      dots: false,
      centerMode: false,
      focusOnSelect: true,
      asNavFor: el.slider,
      responsive: [
        {
          breakpoint: 991.98,
          settings: {
            vertical: false,
            verticalSwiping: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
          },
        },
        {
          breakpoint: 767.98,
          settings: {
            vertical: false,
            verticalSwiping: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            variableWidth: true,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            vertical: false,
            verticalSwiping: false,
            slidesToShow: 6,
            slidesToScroll: 6,
            variableWidth: false,
          },
        },
      ],
    })
    $(el.navs).eq(0).addClass("slick-active")

    $(el.gallery).slick({
      slidesToShow: 2,
      slidesToScroll: 1,
      infinite: false,
      speed: 1000,
      arrows: false,
      dots: false,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 991.98,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 767.98,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
        {
          breakpoint: 575.98,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          },
        },
      ],
    })
  }

  init()
}

crebosCulture()
